'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = JobListing;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _objAsArray = require('shared/utils/objAsArray');

var _objAsArray2 = _interopRequireDefault(_objAsArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'job-listing';

var getTotalSkills = function getTotalSkills(skills) {
  return (0, _keys2.default)(skills).map(function (skillId) {
    return skills[skillId];
  }).length;
};

var getMatchedSkills = function getMatchedSkills(jobSkills, userSkills) {
  return (0, _objAsArray2.default)(jobSkills).reduce(function (sum, job) {
    if (job.id && userSkills.indexOf(job.id.toString()) !== -1) return ++sum;
    return sum;
  }, 0);
};

function JobListing(_ref) {
  var title = _ref.title,
      content = _ref.content,
      image = _ref.image,
      fullSlug = _ref.fullSlug,
      subsectors = _ref.subsectors,
      skills = _ref.skills,
      matches = _ref.matches,
      userSkills = _ref.userSkills;

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    _react2.default.createElement(
      'div',
      { className: CLASS_NAME + '-match' },
      _react2.default.createElement(
        'div',
        { className: 'c-tooltip' },
        (matches.match * 100).toFixed(0),
        '%',
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'label',
          null,
          'match'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: CLASS_NAME + '-image' },
      _react2.default.createElement('img', { src: image, alt: title })
    ),
    _react2.default.createElement(
      'div',
      { className: CLASS_NAME + '-content' },
      _react2.default.createElement(
        'div',
        { className: CLASS_NAME + '-header' },
        _react2.default.createElement(
          'h3',
          null,
          _react2.default.createElement(
            'span',
            null,
            'Job:'
          ),
          '\xA0',
          _react2.default.createElement(
            _reactRouter.Link,
            { to: fullSlug },
            title
          )
        ),
        _react2.default.createElement(
          'h4',
          null,
          _react2.default.createElement(
            'span',
            null,
            'Sub-Sectors:\xA0'
          ),
          subsectors.map(function (sector) {
            return _react2.default.createElement(
              _reactRouter.Link,
              {
                key: sector.fullSlug,
                to: sector.fullSlug
              },
              sector.label
            );
          })
        )
      ),
      _react2.default.createElement(
        'p',
        null,
        content
      ),
      _react2.default.createElement(
        'div',
        { className: CLASS_NAME + '-statistics' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            getMatchedSkills(skills, userSkills),
            '/',
            getTotalSkills(skills)
          ),
          _react2.default.createElement('br', null),
          'Skills'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            (matches.interest * 100).toFixed(0),
            '%'
          ),
          _react2.default.createElement('br', null),
          'Interests'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            matches.education.toFixed(0),
            '%'
          ),
          _react2.default.createElement('br', null),
          'Education'
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobList/JobListing.jsx
// module id = 1185
// module chunks = 0